import { Component, input } from '@angular/core';

@Component({
  selector: 'cipo-video-player',
  templateUrl: './video-player.component.html',
})
export class VideoPlayerComponent {
  source = input.required<string>();
}
